import React, { useState } from "react";

import { InputAdornment } from "@mui/material";
import { TextFieldProps } from "@mui/material";

import { TextField } from "./TextField";

interface PasswordFieldProps extends Omit<TextFieldProps, "type"> {
    name: string;
    showErrorOnSubmit?: boolean;
}

const PasswordField = (props: PasswordFieldProps) => {
    const [showPassword, setShowPassword] = useState(false);
    return (
        <TextField
            {...props}
            type={showPassword ? "text" : "password"}
            slotProps={{
                ...props.slotProps,
                input: {
                    ...props.slotProps?.input,
                    endAdornment: (
                        <InputAdornment position="end">
                            <div style={{ width: "20px", textAlign: "center" }}>
                                <i
                                    className={showPassword ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setShowPassword((prev) => !prev)}
                                />
                            </div>
                        </InputAdornment>
                    ),
                },
            }}
        />
    );
};

export default PasswordField;
